import { useState, useEffect } from 'react';
import { checkForUpdate, applyUpdate, VersionInfo, saveLocalVersion } from './versionCheck';

export function UpdatePrompt() {
  const [updateInfo, setUpdateInfo] = useState<{
    type: 'prompt' | 'force';
    changelog: string | null;
    remoteVersion: VersionInfo;
  } | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // 启动时检查更新
    checkForUpdate().then((result) => {
      if (!result?.hasUpdate) return;
      
      if (result.updateType === 'silent') {
        // 静默更新：直接保存版本号，下次刷新生效
        if (result.remoteVersion) {
          saveLocalVersion(result.remoteVersion.version, result.remoteVersion.build);
        }
        return;
      }
      
      if (result.updateType === 'prompt' || result.updateType === 'force') {
        setUpdateInfo({
          type: result.updateType,
          changelog: result.changelog,
          remoteVersion: result.remoteVersion!,
        });
      }
    });
  }, []);

  if (!updateInfo || dismissed) return null;

  const handleUpdate = () => {
    applyUpdate(updateInfo.remoteVersion);
  };

  const handleDismiss = () => {
    if (updateInfo.type === 'force') return; // 强制更新不能忽略
    setDismissed(true);
  };

  // 强制更新：全屏弹窗
  if (updateInfo.type === 'force') {
    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
      }}>
        <div style={{
          background: 'var(--bg-card)',
          border: '2px solid var(--border-color)',
          padding: '24px',
          maxWidth: '360px',
          width: '100%',
        }}>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: 700, 
            marginBottom: '12px',
            textTransform: 'uppercase',
          }}>
            🚀 重要更新
          </h2>
          {updateInfo.changelog && (
            <p style={{ 
              fontSize: '14px', 
              color: 'var(--text-secondary)',
              marginBottom: '16px',
              lineHeight: 1.5,
            }}>
              {updateInfo.changelog}
            </p>
          )}
          <button
            onClick={handleUpdate}
            style={{
              width: '100%',
              padding: '14px',
              background: 'var(--accent-cyan)',
              border: '2px solid var(--border-color)',
              fontSize: '14px',
              fontWeight: 700,
              textTransform: 'uppercase',
              cursor: 'pointer',
            }}
          >
            立即更新
          </button>
        </div>
      </div>
    );
  }

  // 提示更新：底部 Toast
  return (
    <div style={{
      position: 'fixed',
      bottom: '80px',
      left: '16px',
      right: '16px',
      background: 'var(--bg-card)',
      border: '2px solid var(--border-color)',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      zIndex: 1000,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '13px', fontWeight: 600 }}>
          🆕 有新版本可用
        </div>
        {updateInfo.changelog && (
          <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '2px' }}>
            {updateInfo.changelog}
          </div>
        )}
      </div>
      <button
        onClick={handleDismiss}
        style={{
          padding: '6px 12px',
          background: 'transparent',
          border: '1px solid var(--border-color)',
          fontSize: '12px',
          cursor: 'pointer',
        }}
      >
        稍后
      </button>
      <button
        onClick={handleUpdate}
        style={{
          padding: '6px 12px',
          background: 'var(--accent-cyan)',
          border: '2px solid var(--border-color)',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        刷新
      </button>
    </div>
  );
}
